import { ADMIN_TOKEN_KEY, CLOUD_CLIENT_BASE_URL } from '@/admin-config';

export class AdminApiError extends Error {
  status: number;
  code?: string;
  constructor(message: string, status: number, code?: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

export function getAdminToken(): string {
  try {
    return localStorage.getItem(ADMIN_TOKEN_KEY) || '';
  } catch {
    return '';
  }
}

export function setAdminToken(token: string): void {
  localStorage.setItem(ADMIN_TOKEN_KEY, token);
}

export function clearAdminToken(): void {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
}

export async function adminApi<T = Record<string, unknown>>(
  path: string,
  opts?: RequestInit,
): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...((opts?.headers as Record<string, string>) || {}),
  };
  const token = getAdminToken();
  if (token) headers.Authorization = 'Bearer ' + token;
  const url = path.startsWith('http') ? path : CLOUD_CLIENT_BASE_URL + path;
  const res = await fetch(url, { ...opts, headers });
  const text = await res.text();
  let data: Record<string, unknown> = {};
  try {
    data = text ? (JSON.parse(text) as Record<string, unknown>) : {};
  } catch {
    /* ignore */
  }
  if (!res.ok) {
    throw new AdminApiError(
      String(data.error || 'HTTP ' + res.status),
      res.status,
      typeof data.code === 'string' ? data.code : undefined,
    );
  }
  return data as T;
}
